export default {
  title: `What to use for React styling?`,
  path: `/how-to-style-react`,
  subtitle: `High level overview of all the tools available for styling React components, and how they fit together. Covers PostCSS, Sass, BEM, CSS Modules, Autoprefixer, cssnext, and more.`,
  date: new Date(2016, 3, 14)
};



// WEBPACK FOOTER //
// ./src/guides/how-to-style-react/frontmatter.js